import { CsvFile } from "../CsvFile"
import { BatchItem } from "../BatchItem"

export class FileValidationError extends Error {
    constructor(allowedHeaders: string[]) {
        super(`File must include the following columns: [${allowedHeaders.join(",")}]`)
    }
}

export class BatchFileValidator {
    async validate(file: CsvFile) {
        const errors: Error[] = []
        const data: BatchItem[] = []

        if (!(await file.hasValidHeaders())) {
            errors.push(new FileValidationError(file.allowedHeaders))
        }
        return { data, errors }
    }
}
